<template>
<div class="row">
  <div class="col-md-12" v-loading="loading" element-loading-text="Guardando...">
    <div class="col-md-12">
      <div class="col-md-12">
        <form @submit.prevent="storeClient()">
        <div class="row">
          <div class="col-md-6">

            <div class="vx-card">
              <div class="card-header bg-white">
                <h4 class="card-title">
                  <i class="fa fa-user"></i>
                  Detalle
                </h4>
              </div>

              <div class="card-body">

                <text-input
                  name="name"
                  :label="'Nombre'"
                  v-validate="'required'"
                  :error="errors.first('name')"
                  v-model="client.name"
                  data-vv-as="Nombre">
                </text-input>
                 
                <div class="form-group">
                  <label>Tipo identificación</label>
                  <el-select placeholder="" v-model="client.identification_type" name="identification_type" v-validate="'required'" filterable class="form-control">
                    <el-option
                      v-for="item in identification_types"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value">
                    </el-option>
                  </el-select>
                  <label v-show="errors.has('identification_type')" class="error">
                    {{ errors.first('identification_type') }}
                  </label>
                </div>

                <text-input
                  name="identification"
                  :label="'Identificación'"
                  v-validate="rulesIdentification"
                  :error="errors.first('identification')"
                  v-model="client.identification">
                </text-input>

                <div v-if="client.identification_type == '02' || client.identification_type == '01'">
                  <label>Actividad Económica</label>
                  <div class="mb-3 d-flex" style="gap: 10px;">
                    <el-tooltip content="Buscar actividades económicas" placement="top">
                      <vs-button
                        type="gradient"
                        icon
                        @click="lookupActivities"
                        :disabled="!client.identification || activitiesLoading"
                      >
                        <i :class="['fa', activitiesLoading ? 'fa-spinner fa-spin' : 'fa-search']"></i>
                      </vs-button>
                    </el-tooltip>
                    
                    <el-tooltip content="Agregar actividad manualmente" placement="top">
                      <vs-button
                        type="gradient"
                        icon
                        @click="openManualActivityDialog"
                      >
                        <i class="fa fa-plus"></i>
                      </vs-button>
                    </el-tooltip>
                  </div>

                  <!-- Si el cliente ya tiene actividades guardadas, mostrar solo esas -->
                  <div v-if="client.economic_activity && client.economic_activity.length > 0">
                    <el-select
                      :value="selectedEconomicActivities"
                      @input="updateSelectedActivities"
                      name="economic_activity"
                      placeholder="Actividades económicas del cliente"
                      multiple
                      collapse-tags
                      class="form-control"
                    >
                      <el-option
                        v-for="activity in client.economic_activity"
                        :value="activity"
                        :key="activity.id"
                        :label="activity.id"
                      >
                        <el-tooltip :content="(activity.descripcion || activity.name)" placement="right">
                          <span>{{ activity.id }}</span>
                        </el-tooltip>
                      </el-option>
                    </el-select>
                  </div>
                  
                  <!-- Modo de edición o cuando no hay actividades -->
                  <div v-else-if="enableActivityEditing || (!client.economic_activity || client.economic_activity.length === 0)">
                    <el-select
                      :value="selectedEconomicActivities"
                      @input="updateSelectedActivities"
                      name="economic_activity"
                      placeholder="Seleccione actividad (opcional)"
                      filterable
                      multiple
                      collapse-tags
                      class="form-control"
                    >
                      <el-option
                        v-for="economic_activity in availableActivities"
                        :value="economic_activity"
                        :key="economic_activity.id"
                        :label="economic_activity.id"
                      >
                        <el-tooltip :content="(economic_activity.descripcion || economic_activity.name)" placement="right">
                          <span>{{ economic_activity.id }} - {{ economic_activity.descripcion || economic_activity.name }}</span>
                        </el-tooltip>
                      </el-option>
                    </el-select>
                    
                    <div class="mt-2" v-if="enableActivityEditing">
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-secondary mr-2"
                        @click="cancelActivityEditing"
                      >
                        <i class="fa fa-times"></i> Cancelar
                      </button>
                      <button 
                        type="button" 
                        class="btn btn-sm btn-outline-success"
                        @click="saveActivityChanges"
                      >
                        <i class="fa fa-check"></i> Guardar cambios
                      </button>
                    </div>
                  </div>

                  <div v-else>
                    <el-select
                      v-model="client.economic_activity"
                      name="economic_activity"
                      value-key="id"
                      v-validate="'required'"
                      placeholder=""
                      filterable
                      class="form-control"
                    >
                      <el-option
                        v-for="economic_activity in economic_activities"
                        :value="economic_activity"
                        :key="economic_activity.id"
                        :label="economic_activity.name"
                      >
                      </el-option>
                    </el-select>
                  </div>

                  <label
                    v-show="errors.has('economic_activity')"
                    class="error"
                  >
                    {{ errors.first("economic_activity") }}
                  </label>
                </div>

                <text-input
                  name="email"
                  :label="'Email Principal'"
                  v-validate="'required|email'"
                  :error="errors.first('email')"
                  v-model="client.email">
                </text-input>

                <text-input
                  name="phone"
                  :label="'Teléfono'"
                  v-validate="'required|integer'"
                  :error="errors.first('phone')"
                  v-model="client.phone">
                </text-input>

              </div>

            </div>
          </div>
          
          <div class="col-md-6">
             <div class="vx-card">

              <div class="card-header bg-white">
                <h4 class="card-title">
                  <i class="fa fa-map"></i>
                  Ubicación
                </h4>
              </div>

            <div class="card-body">
            <div :class="['form-group', {'has-danger': errors.has('country') }]">
              <label>País</label>
              <el-select v-model="client.country" value-key="id" name="country" v-validate="'required'" placeholder="" filterable class="form-control">
                <el-option v-for="country in countries"
                  :value="country"
                  :key="country.id"
                  :label="country.name">
                </el-option>
              </el-select>
              <label v-show="errors.has('country')" class="error">
                {{ errors.first('country') }}
              </label>
            </div>
            <div v-show="showProvinceCantonDistrict"> <!-- provincia canton distrito -->
             <div :class="['form-group', {'has-danger': errors.has('province') }]">
              <label>Provincia</label>
              <el-select @change="getCantons()" value-key="id" v-model="client.province" name="province" v-validate="'required'" placeholder="" filterable class="form-control">
                <el-option
                  v-for="province in provinces"
                  :value="province"
                  :key="province.id"
                  :label="province.name">
                </el-option>
              </el-select>
              <label v-show="errors.has('province')" class="error">
                {{ errors.first('province') }}
              </label>
            </div>

             <div :class="['form-group', {'has-danger': errors.has('canton') }]">
              <label>Cantón</label>
              <el-select no-data-text="No hay datos" value-key="id" no-match-text="No hay coincidencias" @change="getDistricts()" v-model="client.canton" name="canton" v-validate="'required'" placeholder="" filterable class="form-control">
                <el-option 
                  v-for="canton in cantons"
                  :value="canton"
                  :key="canton.id"
                  :label="canton.name">
                </el-option>
              </el-select>
              <label v-show="errors.has('canton')" class="error">
                {{ errors.first('canton') }}
              </label>
            </div>

            <div :class="['form-group', {'has-danger': errors.has('district') }]">
              <label>Distrito</label>
              <el-select v-model="client.district" value-key="id" name="district" v-validate="'required'" placeholder="" filterable class="form-control">
                <el-option
                  v-for="district in districts"
                  :value="district"
                  :key="district.id"
                  :label="district.name">
                </el-option>
              </el-select>
              <label v-show="errors.has('district')" class="error">
                {{ errors.first('district') }}
              </label>
            </div>
            </div>
              </div>
              </div>     
          </div>
              
        </div>

        <!-- Separator horizontal -->
        <div class="row">
          <h3 class="separator-horizontal">
            Contactos
          </h3>
        </div>

          <div class="row">
           
              <div v-for="(contact, index) in contacts" :key="index" class="col-md-6">
                <div class="vx-card">
                <div class="card-header bg-white">
                  <h4 class="card-title">Contacto {{ index + 1 }}</h4>
                </div>
                <div class="card-body">

                <text-input
                  :name="'name_'+ index"
                  :label="'Nombre'"
                  v-validate="`${contacts[index].email.length > 0 ? 'required' : ''}`"
                  :error="errors.first('name_'+ index)"
                  v-model="contacts[index].name">
                </text-input>
    
               <text-input
                  :name="'email_'+ index"
                  :label="'Email'"
                  v-validate="`${contacts[index].name.length > 0 ? 'required' : ''}`"
                  :error="errors.first('email_'+ index)"
                  v-model="contacts[index].email">
                </text-input>

                <div>
                  <button type="button" :class="['btn', 'btn-link', 'text-danger', 'float-right', {'oculto': notRemoveContact}]" @click="removeContact(index)">
                    - Remover contacto
                  </button>
                </div>
                </div>
                </div>
          </div> 
          <div class="col-md-12">
          <br>
          <hr />
          <button type="button" class="btn btn-link text-success font-weight-bold" @click="addContact(contacts.length)">
            + Agregar contacto
          </button>
          </div>
          </div>
          <div class="col-md-12 text-right">
            <button type="submit" class="btn btn-success">
              <i class="fa fa-save"></i>
              Guardar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Dialog para agregar actividad manual -->
  <el-dialog
    title="Agregar Actividad Económica Manualmente"
    :visible.sync="manualActivityDialog"
    width="500px"
  >
    <el-form label-position="top">
      <el-form-item label="Código (6 dígitos) *">
        <el-input
          v-model="manualActivity.code"
          placeholder="Ej: 620100"
          maxlength="6"
        ></el-input>
      </el-form-item>

      <el-form-item label="Descripción (Opcional)">
        <el-input
          v-model="manualActivity.description"
          type="textarea"
          :rows="3"
          placeholder="Descripción de la actividad económica (opcional)"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="manualActivityDialog = false">Cancelar</el-button>
      <el-button type="primary" @click="addManualActivity">Agregar</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import clientsService from '@/services/clients.service'
import utilitiesService from '@/services/utilities.service'
import helpers from '@/helpers/helpers'
import { mapState } from 'vuex'

export default {
  name: 'new-client',
  data() {
    return {
      client: {
        economic_activity: [],
        name: "",
        identification_type: "",
        identification: "",
        email: "",
        phone: "",
        country: {
          id: 60
        },
        province: {
          id: 1,
          number: 1
        },
        canton: {
          id: 1,
          number: "01"
        },
        district: {
          id: 1
        },
        contacts: [
          {
            name: "",
            email: ""
          }
        ]
      },
      loading: false,
      economic_activities: [],
      enableActivityEditing: false,
      originalActivities: [],
      manualActivityDialog: false,
      manualActivity: {
        code: '',
        description: '',
        type: 'S'
      },
      activitiesLoading: false
    }
  },
  computed: {
    contacts: function() {
      return this.client.contacts
    },
    notRemoveContact() {
      return this.client.contacts.length == 1;
    },

    ...mapState(['countries',
                  'provinces',
                  'cantons',
                  'districts',
                  'identification_types']),
   
    rulesIdentification() {
      return helpers.validateIdentificationLength(this.client.identification_type)
    },
    showProvinceCantonDistrict() {
      return this.client.country.id !== 60 ? false : true;
    },
    selectedEconomicActivities() {
      // Simplificado para evitar errores
      if (!this.client.economic_activity || !Array.isArray(this.client.economic_activity)) {
        return [];
      }
      return this.client.economic_activity;
    },
    availableActivities() {
      // Combinar las actividades del cliente (si las tiene) con todas las disponibles
      const allActivities = [...this.economic_activities];
      
      // Si el cliente tiene actividades, asegurarse de que estén incluidas en la lista
      if (this.client.economic_activity && this.client.economic_activity.length > 0) {
        this.client.economic_activity.forEach(clientActivity => {
          const exists = allActivities.find(activity => 
            activity.id === clientActivity.id || 
            activity.id === clientActivity.codigo ||
            String(activity.id) === String(clientActivity.id)
          );
          if (!exists) {
            allActivities.push(clientActivity);
          }
        });
      }
      
      return allActivities;
    }
  },
  methods: {
    storeClient() {
      this.loading = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          let _this = this;
          let data = this.client;
          
          // 🔍 Log client data before sending
          console.log('🔍 [CLIENT SAVE] Datos del cliente a guardar:', data);
          console.log('🔍 [CLIENT SAVE] Tipo identificación:', data.identification_type);
          console.log('🔍 [CLIENT SAVE] Actividades económicas:', data.economic_activity);
          if (data.economic_activity && data.economic_activity.length > 0) {
            console.log('🔍 [CLIENT SAVE] Primera actividad:', data.economic_activity[0]);
          }
          
          clientsService.storeClient(data)
          .then(function (response) {
            console.log('✅ [CLIENT SAVE] Respuesta del servidor:', response);
            console.log('✅ [CLIENT SAVE] Response data:', response.data);
            
            _this.loading = false;
            //_this.$snotify.success('Cliente Guardado Correctamente');
            //JRA Cambio de notificacion por mensaje
            _this.$message({
              showClose: true,
              message: 'Cliente Guardado Correctamente',
              type: 'success'
            });
            _this.$router.push({"name" : 'clients'});
          })
          .catch(function (error) {
            console.error('❌ [CLIENT SAVE] Error al guardar:', error);
            console.error('❌ [CLIENT SAVE] Error response:', error.response);
            
            _this.loading = false;
            //_this.$snotify.error(error.response.data.message);
            //JRA Cambio de notificacion por mensaje
            _this.$message({
              showClose: true,
              message: error.response.data.message,
              type: 'error'
            });
          });
        }
      });
      this.loading = false;
    },
    addContact(newIndex) {
      if (this.client.contacts.length == 4) {
        //this.$snotify.info(`No puede agregar mas de ${this.client.contacts.length} contactos`);
        //JRA Cambio de notificacion por mensaje
        this.$message({
          showClose: true,
          message: `No puede agregar mas de ${this.client.contacts.length} contactos`,
          type: 'info'
        });
        return;
      }

      this.$set(this.client.contacts, newIndex, {
        name: "",
        email: ""
      });
    },
    removeContact(index) {
      if (this.client.contacts.length == 1) return;
      this.client.contacts.splice(index, 1);
    },
    getCountries() {
     this.$store.dispatch('getCountries', {});
    },
    getProvinces() {
      this.$store.dispatch('getProvinces', {});
      this.getCantons();
    },
    getCantons() {
      this.$store.dispatch('getCantons', {province: this.client.province.number})
      .then(res => {
        this.client.canton = res[0];
        this.getDistricts();
      });
    },
    getDistricts() {
      let province = this.client.province.number;
      let canton = this.client.canton.number;
      this.$store.dispatch('getDistricts', {province: province, canton: canton})
      .then(res => {
        this.client.district = res[0];
      });
    },
    enableActivityEditingMode() {
      this.originalActivities = [...(this.client.economic_activity || [])];
      this.enableActivityEditing = true;
    },
    cancelActivityEditing() {
      this.client.economic_activity = [...this.originalActivities];
      this.enableActivityEditing = false;
      this.originalActivities = [];
    },
    saveActivityChanges() {
      // Las actividades ya están actualizadas en this.client.economic_activity
      this.enableActivityEditing = false;
      this.originalActivities = [];
      // Aquí podrías llamar a updateClient() si quisieras guardar automáticamente
    },
    updateSelectedActivities(newValue) {
      console.log('UPDATE - New value received:', newValue);
      
      // Limpiar cualquier información adicional de las actividades seleccionadas
      const cleanActivities = newValue.map(activity => {
        const cleanActivity = { ...activity };
        delete cleanActivity.company_name;
        delete cleanActivity.regimen;
        delete cleanActivity.found_company_name;
        delete cleanActivity.found_regimen;
        return cleanActivity;
      });
      
      this.$set(this.client, 'economic_activity', cleanActivities);
      console.log('UPDATE - Updated client.economic_activity:', this.client.economic_activity);
    },
    getEconomicActivities() {
      utilitiesService
        .getEconomicActivities()
        .then(res => {
          console.log('GET ECONOMIC ACTIVITIES - Response:', res.data);
          this.economic_activities = res.data;

          // Force reactivity update after economic_activities are loaded
          console.log('GET ECONOMIC ACTIVITIES - Current client state:', {
            'client.economic_activity': this.client.economic_activity,
            'client.economic_activities': this.client.economic_activities
          });
          
          // Ensure selected activities are updated with complete data from economic_activities
          if (this.client.economic_activity && Array.isArray(this.client.economic_activity)) {
            console.log('GET ECONOMIC ACTIVITIES - Updating selected activities with complete data');
            this.$nextTick(() => {
              this.$forceUpdate();
            });
          }
        })
        .catch(error => {
          alert(error);
        });
    },
    async lookupActivities() {
      if (this.activitiesLoading) return;
      if (!this.client.identification || !this.client.identification_type) {
        this.$message({ type: 'warning', message: 'Ingrese tipo y número de identificación' });
        return;
      }
      if (this.client.identification_type !== '02' && this.client.identification_type !== '01') {
        this.$message({ type: 'warning', message: 'La búsqueda de actividades económicas solo aplica a cédulas físicas y jurídicas' });
        return;
      }
      this.activitiesLoading = true;
      try {
        const { data: res } = await utilitiesService.getActivitiesByIdentification(this.client.identification, this.client.identification_type);
        console.log('[ACTIVITIES][SUCCESS] Respuesta:', res);
        if (!res) {
          this.$message({ type: 'error', message: 'Respuesta vacía del servidor' });
          return;
        }
        if (res.success) {
          const mapped = (res.activities || []).map(a => ({
            id: a.codigo_original || a.codigo,
            descripcion: a.descripcion,
            name: a.descripcion,
            tipo: a.tipo,
            tipo_descripcion: a.tipo_descripcion
          }));
          this.client.economic_activities = mapped;
          if (!mapped.length) {
            this.$message({ type: 'info', message: 'No se encontraron actividades activas' });
            return;
          }
          const principal = mapped.find(a => a.tipo === 'P') || mapped[0];
            this.client.economic_activity = [principal];
            this.$message({ type: 'success', message: 'Actividades cargadas' });
        } else {
          this.$message({ type: 'error', message: res.message || 'No se encontraron actividades' });
        }
      } catch (error) {
        console.error('[ACTIVITIES][ERROR]', error && error.response ? error.response : error);
        let msg = 'Error conectando con Hacienda';
        if (error.response) {
          if (error.response.status === 404) msg = 'No se encontraron actividades';
          else if (error.response.status === 401) msg = 'Sesión no autorizada (401)';
          else if (error.response.status >= 500) msg = 'Error en el servidor';
        }
        this.$message({ type: 'error', message: msg });
      } finally {
        this.activitiesLoading = false;
      }
    },
    openManualActivityDialog() {
      this.manualActivity = {
        code: '',
        description: '',
        type: 'S'
      };
      this.manualActivityDialog = true;
    },
    addManualActivity() {
      if (!this.manualActivity.code || this.manualActivity.code.length !== 6) {
        this.$message({ type: 'warning', message: 'El código debe tener 6 dígitos' });
        return;
      }

      const description = this.manualActivity.description || `Actividad ${this.manualActivity.code}`;

      const newActivity = {
        id: this.manualActivity.code,
        codigo: this.manualActivity.code,
        descripcion: description,
        name: description,
        tipo: 'S',
        tipo_descripcion: 'Servicio'
      };

      // Agregar a las actividades disponibles si no existe
      if (!this.client.economic_activities) {
        this.client.economic_activities = [];
      }
      
      const exists = this.client.economic_activities.find(a => a.id === newActivity.id);
      if (!exists) {
        this.client.economic_activities.push(newActivity);
      }

      // Agregar a las actividades seleccionadas
      if (!this.client.economic_activity) {
        this.client.economic_activity = [];
      }
      
      const alreadySelected = this.client.economic_activity.find(a => a.id === newActivity.id);
      if (!alreadySelected) {
        this.client.economic_activity.push(newActivity);
        this.$message({ type: 'success', message: 'Actividad agregada correctamente' });
      } else {
        this.$message({ type: 'info', message: 'Esta actividad ya está seleccionada' });
      }

      this.manualActivityDialog = false;
    }

  },
  created() {
    this.getCountries();
    this.getProvinces();
    this.getEconomicActivities();
  }
}
</script>

<style scope>

.box-shadow {
  box-shadow: 0 0 2px rgb(136, 124, 124) !important;
}

.oculto {
  display: none;
}

</style>
